import PropTypes from 'prop-types';
import React from 'react';

import Container from '@glass/web/components/Layout/Container';
import Alert from '@glass/web/components/base/Alert';
import Button from '@glass/web/components/base/Button';
import useClientReadyRouter from '@glass/web/modules/router/useClientReadyRouter';
import GlobalStyles from '@glass/web/modules/theme/GlobalStyles';
import makeStyles from '@glass/web/modules/theme/makeStyles';
import { DEFAULT_SPACING } from '@glass/web/modules/theme/spacing';

import ConsumerLayoutPage from '@glass/shared/components/Layout/ConsumerLayoutPage';
import Footer from '@glass/shared/components/Layout/Footer/Footer';
import Header from '@glass/shared/components/Layout/Header/Header';
import {
  DISABLE_LOADING,
  LAZY_LOADING,
  SSR_LOADING,
} from '@glass/shared/components/Section/loadingMethods';
import emphasis from '@glass/shared/modules/theme/styles/emphasis';
import themeColor from '@glass/shared/modules/theme/styles/themeColor';

const useStyles = makeStyles()((theme) => ({
  container: {
    paddingBottom: theme.spacing(DEFAULT_SPACING),
  },
}));

function ResourceLayoutPage({
  children,
  preview,
  resourceSectionLoadingMethod,
  color,
  pageTitle,
  description,
  canonicalPath,
}) {
  const { classes } = useStyles();
  const { isClientReady, asPath } = useClientReadyRouter();

  return (
    <ConsumerLayoutPage
      canonicalPath={canonicalPath}
      description={description}
      footer={
        <Footer
          resourceSectionLoadingMethod={resourceSectionLoadingMethod}
          supportSectionLoadingMethod={DISABLE_LOADING}
        />
      }
      header={<Header addFixedHeaderSpacing matchTheme transparent tintColor={color} />}
      pageTitle={pageTitle}
    >
      <GlobalStyles
        styles={{
          em: emphasis({ color, opacity: 0.1 }),
        }}
      />
      <div className={classes.container}>
        {preview ? (
          <Container isNoYPadding>
            <Alert
              action={
                <Button
                  color="inherit"
                  component="a"
                  disabled={!isClientReady}
                  href={isClientReady ? `/api/_internal/clearPreview?path=${asPath}` : ''}
                  size="small"
                >
                  Exit
                </Button>
              }
              severity="info"
            >
              Preview Mode
            </Alert>
          </Container>
        ) : null}
        {children}
      </div>
    </ConsumerLayoutPage>
  );
}

ResourceLayoutPage.defaultProps = {
  color: themeColor,
};

ResourceLayoutPage.propTypes = {
  canonicalPath: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  description: PropTypes.string,
  pageTitle: PropTypes.string,
  preview: PropTypes.bool,
  resourceSectionLoadingMethod: PropTypes.oneOf([DISABLE_LOADING, LAZY_LOADING, SSR_LOADING]),
};

export default ResourceLayoutPage;
